import { UrlMatchResult, UrlSegment } from '@angular/router';

/**
 * Permite URLs hierárquicas ilimitadas após /pages.
 *
 * Exemplos:
 * /pages/biblioteca
 * /pages/biblioteca/acesso_a_base_de_dados_online
 * /pages/graduacao/medicina/2026/semestre/1
 */
export function pagesMatcher(
  segments: UrlSegment[]
): UrlMatchResult | null {

  if (segments.length < 2) {
    return null;
  }

  if (segments[0].path !== 'pages') {
    return null;
  }

  const nomePagina = segments
    .slice(1)
    .map((segment: UrlSegment) => segment.path)
    .join('/');

  return {
    consumed: segments,
    posParams: {
      nome: new UrlSegment(nomePagina, {})
    }
  };
}